export default function reducer(state = {
  outlet:    {
    eircode: '',
    passcode: '',
    customer_number:   ''
  },
  questions: [],
  fetching:  false,
  fetched:   false,
  errors:    {},
}, action) {
  switch (action.type) {
    case 'GET_YOU_PENDING':
    case 'UPDATE_YOU_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_YOU_FULFILLED':
    case 'UPDATE_YOU_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched:  true,
        user:    action.payLoad,
      }
    }
    case 'GET_YOU_REJECTED':
    case 'UPDATE_YOU_REJECTED': {
      return {
        ...state, errors: action.payLoad
      }
    }
    case 'OUTLET_VALIDATION_FULFILLED': {
      return {
        ...state,
        outlet: {
          eircode: action.payLoad.eircode,
          passcode: action.payLoad.passcode,
          pay_for_performance: action.payLoad.pay_for_performance,
          reward_store: action.payLoad.reward_store,
          customer_number: action.payLoad.customer_number,
          registration_token: action.payLoad.registration_token,
        }
      }
    }
    case 'INVITATION_TOKEN_FULFILLED': {
      return {
        ...state,
        outlet: {
          reward_store: action.payLoad.outlet.pfp,
        }
      }
    }
    case 'SECURITY_QUESTIONS_FULFILLED': {
      return {
        ...state,
        questions: action.payLoad
      }
    }
    default:
  }

  return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/aboutYouReducer.js